export const getQueryString = (key: string): string => new URLSearchParams(window.location.search).get(key) ?? "0";
